module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/coj_c-4-82850bc3ee4284424ecb7d9b2a3b231f.jpg";